<template>
  <article>
    <vs-row align="center" justify="center">
      <img class="logo" :src="logo_url"/>
    </vs-row>
    <vs-row align="center" justify="center">
      <h2>
        First things first
      </h2>
      <h3>Enter your information below to get started </h3>
    </vs-row>
    <vs-row align="center" justify="center">
      <form @submit.prevent="checkoutPayload">
        <vs-row align="left" justify="left">
          <label class="required-label">REQUIRED FIELDS*</label>
        </vs-row>
        <vs-row vs-type="flex" align="center" justify="center">
          <vs-col 
            :xs="12" 
            :sm="12" 
            :lg="6" 
            vs-type="flex" 
            align="center" 
            justify="center"
          >
            <vs-input
              id="input-components-checkout-firstname"
              label="FIRST NAME*"
              v-model="checkout.firstName"
              placeholder="Joe" 
              color="#83bc00" 
              required 
            />
          </vs-col>
          <vs-col
            :xs="12" 
            :sm="12" 
            :lg="6" 
            vs-type="flex" 
            align="center" 
            justify="center"
          >
            <vs-input 
              id="input-components-checkout-lastname"
              label="LAST NAME*" 
              v-model="checkout.lastName" 
              placeholder="Smith" 
              color="#83bc00" 
              required 
            />
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" align="center" justify="center">
          <vs-col 
            :xs="12" 
            :sm="12" 
            :lg="6" 
            vs-type="flex" 
            align="center" 
            justify="center"
          >
            <vs-input 
              id="input-components-checkout-email"
              label="EMAIL*" 
              v-model="checkout.email" 
              type="email" 
              color="#83bc00" 
              required 
            />
          </vs-col>
          <vs-col 
            :xs="12" 
            :sm="12" 
            :lg="6" 
            vs-type="flex" 
            align="center" 
            justify="center"
          >
            <div class="vs-input-parent vs-input-parent--state-null vs-input-content--has-label vs-change-color">
              <flat-pickr
                id="input-components-checkout-dob"
                v-model="checkout.dob" 
                :class="'flat-calendar-picker '+(dateNotValid ? 'no-valid': '')"
                ref="datepicker" 
                :config="dateConfig"
                placeholder="MM/DD/YYYY"
                :disabled="false"
              ></flat-pickr>
              <label 
                for="vs-input--148" 
                class="vs-input__label vs-input__label--label"
              >DATE OF BIRTH{{allowGiftSite ? '' : '*'}}</label>
              <span v-if="!!errorDOBInput" class="error">{{ errorDOBInput }}</span>
            </div>
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" align="center" justify="center">
          <vs-col 
            :xs="12" 
            :sm="12" 
            :lg="6" 
            vs-type="flex" 
            align="center" 
            justify="center"
          >
            <vs-input 
              id="input-components-checkout-address"
              ref="checkout_address"
              label="ADDRESS*" 
              color="#83bc00" 
              v-model="checkout.address" 
              required 
            />
          </vs-col>
          <vs-col 
            :xs="12" 
            :sm="12" 
            :lg="6" 
            vs-type="flex" 
            align="center" 
            justify="center"
          >
            <vs-input 
              id="input-components-checkout-city"
              label="CITY*" 
              color="#83bc00" 
              v-model="checkout.city" 
              required 
            />
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" align="center" justify="center">
          <vs-col 
            :xs="12" 
            :sm="12" 
            :lg="6" 
            vs-type="flex" 
            align="center" 
            justify="center"
          >
            <div 
            class="vs-input-parent" required="required"
            >
              <div 
              class="vs-input-content"
              >
                <label 
                  class="vs-input__label vs-input__label--label"
                  >STATE*</label
                >
                <select 
                  id="select-components-checkout-state"
                  class="vs-input" 
                  v-model="checkout.state" 
                  required
                >
                  <option 
                    :value="state.abbreviation" 
                    v-for="(state) in stateList" 
                    :key="state.abbreviation"
                  >
                    {{ state.name }}
                  </option>
                </select>
              </div>
            </div>
          </vs-col>
          <vs-col 
            :xs="12" 
            :sm="12" 
            :lg="6" 
            vs-type="flex" 
            align="center" 
            justify="center"
          >
            <vs-input 
              id="input-components-checkout-zipcode"
              label="ZIP CODE*" 
              color="#83bc00" 
              v-model="checkout.zip" 
              required 
            />
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" align="center" justify="center" v-if="validation === 'email_dob_phonenumber' || allowPhone">
          <vs-col 
            :xs="12" 
            :sm="12" 
            :lg="6" 
            vs-type="flex" 
            align="center" 
            justify="center"
          >
            <vs-input 
              id="input-components-checkout-phonenumber"
              :label="`PHONE NUMBER${validation === 'email_dob_phonenumber' ? '*' : ''}`" 
              v-model="checkout.phone_number" 
              type="tel" 
              color="#83bc00" 
              :required="validation === 'email_dob_phonenumber'" 
            />
          </vs-col>
          <vs-col 
            :xs="12" 
            :sm="12" 
            :lg="6" 
            vs-type="flex" 
            align="center" 
            justify="center"
          >&nbsp;</vs-col>
        </vs-row>
        <vs-row vs-type="flex" align="center" justify="center">
          <vs-col 
            :xs="12" 
            :sm="12" 
            :lg="12" 
            vs-type="flex" 
            align="left" 
            justify="left"
          >
            <vs-checkbox 
              id="checkbox-components-checkout-acceptrules"
              v-model="checkboxValidation" 
              required
            >{{contentCopies.form_label_terms}}</vs-checkbox>
          </vs-col>
        </vs-row>
        <vs-row vs-type="flex" align="center" justify="center" class="mt-2">
          <vs-col vs-type="flex" align="center" justify="center">
            <vs-button id="btn-components-checkout-next" color="#83bc00" size="large" square>
              NEXT
            </vs-button>
          </vs-col>
        </vs-row>
      </form>
    </vs-row>
  </article>
</template>

<script>
import moment from 'moment';
import FlatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/themes/material_green.css'
import 'flatpickr/dist/plugins/confirmDate/confirmDate.css';

let states = require('../assets/states.js');

export default {
  props: {
    promoName: {
      type: String,
      required: true,
    },
    validation: {
      type: String,
      required: true,
    },
    logo:{
      type:String,
      require:false
    },
    logo_url:{
      type:String,
      require:false
    },
    code: {
      type: String,
      required: false,
    },
    addressValidation: {
      type: Boolean,
      required: false,
    },
    contentCopies: {
      type: Object,
      require: true,
    },
    allowGiftSite: {
      type: Boolean,
      required: false,
    },
    allowPhone: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    FlatPickr,
  },
  methods: {
    checkoutPayload() {
      const urlValidateAddress = `redeem/winners/validateAddress?redeemToken=${this.code}`;
      
      this.dateNotValid = false;
      if(!this.checkout.dob && !this.allowGiftSite){
        this.dateNotValid = true;
        this.errorDOBInput = 'Required.';
        return;
      }
      
      if(this.addressValidation){
        this.$http.post(urlValidateAddress, {
          ...this.checkout,
          dob: this.checkout.dob ? this.checkout.dob : '1800-01-01',
        }).then(result => {
          if(result.data.valid){
            this.$emit('success', this.checkout);
          }
        }).catch((error) => {
          this.$emit('error', this.getErrorMessage(error), true, this.code);
        });
      } else {
        this.$emit('success', this.checkout);
      }
      
    },
    moment,
  },
  data() {
    return {
      checkout: {},
      dateNotValid:false,
      checkboxValidation:false,
      stateList: states,
      errorDOBInput: '',
      dateConfig: {
        maxDate: new Date(),
        altInput: true,
        altFormat: "m/d/Y",
        dateFormat: "Y-m-d",
        enableTime: false,
      }
    };
  },
  watch: {
    'checkout.dob': function(newVal) {
      if(newVal) {
        this.errorDOBInput = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
article {
  width: 100%;

  form {
    width: 50%;
    @media only screen and (max-width: 768px) {
      width: 100%;
    }
    .vs-checkbox-content{
      margin: 2rem;
    }


  }
}

::v-deep form{
  @media only screen and (max-width: 768px) {
    input[type='text'],
    input[type='number'],
    textarea,
    input {
      font-size: 16px;
    }
  }
}
::v-deep .vs-checkbox-label{
  padding-left:30px;
}
::v-deep .vs-checkbox-content .vs-checkbox-con{
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

h1,
h2 {
  font-size: 42px;
  font-weight: bold;
  margin: 0.5rem 0;
  text-transform: uppercase;
  width:100%;
}

h2 {
  color: #83bc00;
}

h3 {
  font-weight: 700;
  margin: 1rem 0;
}
.logo{
  max-width: 200px;
}

.mt-2 {
  margin-top: 2rem;
}

.required-label{
  margin-left:2.5rem;
}

::v-deep .ant-calendar-picker {
  border-radius: 12px;
  width: 100%;

  input {
    background: rgba(var(--vs-gray-2), 1);
    border: none;
    border-radius: 12px;
  }
  &.no-valid {
    input:focus{
      box-shadow: 0 0 0 2px rgb(255 24 99 / 20%);
    }
  }
}

::v-deep .flat-calendar-picker {
  padding: 4px 11px;
  background: rgba(var(--vs-gray-2), 1);
  border: none;
  border-radius: 12px;
  &::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color: #bfbfbf;
  }
  &::-moz-placeholder { /* Firefox 19+ */
    color: #bfbfbf;
  }
  &:-ms-input-placeholder { /* IE 10+ */
    color: #bfbfbf;
  }
  &:-moz-placeholder { /* Firefox 18- */
    color: #bfbfbf;
  }
  &.no-valid:focus {
    box-shadow: 0 0 0 2px rgb(255 24 99 / 20%);
  }
}

::v-deep .vs-col--w-6 {
  display: flex !important;
}

::v-deep .vs-icon-check span .line1 {
  width: 5px;
}

::v-deep .vs-input-parent {
  margin: 1.5rem auto;
  width: 80%;

  .vs-input {
    width: 100%;
  }
}

@media (max-width: 768px) {
  h1{
    font-size: 34px;
  }
  h2{
    font-size: 28px;
  }
  h3{
    font-size: 12px;
  }
}
.error {
  color: #f27474;
  text-align: left;
  font-size: 13px;
  line-height: 13px;
  margin-left: 10px;
}
</style>
